export default {
  name: 'ColorsMixin',
  computed: {
    colors() {
      return [
        { text: this.$i18n_t('DigitalTwin.DigitalTwin.visualization.colors.lightGreen'), value: '#7cb342' },
        { text: this.$i18n_t('DigitalTwin.DigitalTwin.visualization.colors.red'), value: '#ff1744' },
        { text: this.$i18n_t('DigitalTwin.DigitalTwin.visualization.colors.orange'), value: '#fb8c00' },
        { text: this.$i18n_t('DigitalTwin.DigitalTwin.visualization.colors.yellow'), value: '#fec60a' },
        { text: this.$i18n_t('DigitalTwin.DigitalTwin.visualization.colors.darkGreen'), value: '#388e3c' },
        { text: this.$i18n_t('DigitalTwin.DigitalTwin.visualization.colors.lightBlue'), value: '#40c4ff' },
        { text: this.$i18n_t('DigitalTwin.DigitalTwin.visualization.colors.darkBlue'), value: '#0091ea' },
      ];
    },
  },
};
